export default {
  cart: {
    back: 'Voltar',
    title: 'Carrinho ({{count}})',
    empty: 'O seu carrinho está vazio.',
    signIn: {
      title: 'Já tem conta?',
      description: 'Inicie sessão ou registe-se para uma melhor experiência.',
      button: 'Iniciar sessão',
    },
    item: {
      quantity: 'Qtd: {{count}}',
      decreaseQuantity: 'Diminuir quantidade',
      increaseQuantity: 'Aumentar quantidade',
      unitPrice: 'Preço Unitário',
      discount: 'Desconto',
      finalPrice: 'Preço Final',
      perUnitSuffix: '/ un.',
      additionalDetails: 'Detalhes adicionais de {{name}}',
      collapseDetails: 'Ocultar detalhes',
      expandDetails: 'Expandir detalhes',
      removeItem: 'Remover {{name}}',
    },
    summary: {
      title: 'Resumo',
      subtotal: 'Subtotal',
      itemsCount: '({{count}} Items)',
      discounts: 'Descontos',
      shipping: 'Envio',
      free: 'Grátis',
      taxes: 'Impostos',
      total: 'Total',
      checkoutButton: 'Finalizar Encomenda',
      savingBudget: 'A guardar...',
      saveAsBudgetButton: 'Guardar como Orçamento',
      invalidZeroPriceWarning: 'O carrinho contém produtos com preço sob consulta. Remova-os para continuar.',
    },
    coupon: {
      label: 'Adicionar código de desconto',
      placeholder: 'Inserir código',
      applying: 'A aplicar...',
      apply: 'Aplicar',
      removeAria: 'Remover código {{code}}',
      invalidCode: 'Código de desconto inválido.',
      applied: 'Código de desconto aplicado.',
      applyError: 'Erro ao aplicar o código de desconto.',
      removed: 'Código de desconto removido.',
      removeError: 'Erro ao remover o código de desconto.',
      disabledNote: 'Apenas um desconto pode estar ativo de cada vez. Remova o desconto atual para aplicar um código diferente.',
    },
    discounts: {
      loyalty: {
        redeem: 'Resgatar pontos',
        applied: 'Pontos resgatados',
        remove: 'Remover',
        description: 'Utilize até {{maxRedeemablePoints}} pontos para um desconto',
        applyError: 'Erro ao resgatar pontos.',
        removeError: 'Erro ao remover os pontos resgatados.',
      },
      client: {
        cta: 'Tem direito a um desconto',
        apply: 'Aplicar',
        applied: 'Desconto aplicado',
        remove: 'Remover',
        applyError: 'Erro ao aplicar o desconto.',
        removeError: 'Erro ao remover o desconto.',
      },
      other: {
        applied: '{{description}} aplicado',
        remove: 'Remover',
        removeError: 'Erro ao remover o desconto.',
      },
    },
    toast: {
      budgetSaved: 'Orçamento guardado com sucesso!',
      itemRemoved: 'Item removido do carrinho.',
      kitRemoved: 'Kit removido do carrinho.',
    },
    errors: {
      budgetSaveError: 'Erro ao guardar como orçamento.',
      updateQuantity: 'Erro ao atualizar quantidade.',
      removeItem: 'Erro ao remover item.',
      removeItemFromCart: 'Erro ao remover item do carrinho.',
      removeKit: 'Erro ao remover o kit do carrinho.',
      clearCart: 'Erro ao limpar o carrinho.',
      noActiveOrder: 'Não foi possível obter o carrinho ativo.',
      startCart: 'Não foi possível iniciar o carrinho.',
      addBundle: 'Erro ao adicionar conjunto ao carrinho.',
      addKit: 'Erro ao adicionar o kit ao carrinho.',
    },
  },
  payment: {
    title: 'Pagamento',
    preparing: 'A preparar o pagamento...',
    retry: 'Tentar novamente',
    success: {
      title: 'Pagamento Concluído!',
      description: 'O seu pagamento foi processado com sucesso. A sua encomenda está agora a ser preparada para envio.',
      viewOrder: 'Ver Detalhes da Encomenda',
      continueShopping: 'Continuar a Comprar',
      toast: 'Pagamento efetuado com sucesso!',
    },
    fail: {
      title: 'Pagamento Falhou',
      description: 'Não foi possível processar o seu pagamento. Por favor, verifique os dados inseridos ou tente um método de pagamento diferente.',
      retry: 'Tentar Novamente',
      backToCart: 'Voltar ao Carrinho',
    },
    errors: {
      checkoutExpired: 'A sessão de pagamento expirou. Por favor, tente novamente.',
      alreadyPaid: 'Esta encomenda já foi paga.',
      checkoutCanceled: 'Pagamento cancelado.',
      generic: 'Não foi possível processar o pagamento. Por favor, tente novamente.',
      startFailed: 'Não foi possível iniciar a sessão de pagamento.',
      initFailed: 'Falha ao iniciar o pagamento.',
    },
  },
}
